export default class {
	constructor(selector) {
		this.element = selector;
		this.handlers = {
			update: [],
		};
		this.initObserver();
	}

	initObserver() {
		const config = {
			attributes: true,
		};

		const callback = (mutationsList) => {
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'attributes') {
					this.emit('update');
				}
			});
		};

		this.observer = new MutationObserver(callback);
		this.observer.observe(this.element, config);
	}

	destroy() {
		this.observer.disconnect();
	}

	onUpdate(handler) {
		this.handlers.update.push(handler);
	}

	emit(event) {
		this.handlers[event].forEach((item) => {
			item.call(this, event);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/obervers/element-attribute-oberver.js